import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeDiff'
})
export class TimeDiffPipe implements PipeTransform {
  language = localStorage.getItem('language') || 'en';

  constructor(public translate: TranslateService) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    translate.use(this.language);
  }


  transform(value: any, customSuffix?: string): any {
    const units = [
      { key: 'year', seconds: 31536000 },
      { key: 'month', seconds: 2592000 },
      { key: 'week', seconds: 604800 },
      { key: 'day', seconds: 86400 },
      { key: 'hour', seconds: 3600 },
      { key: 'minute', seconds: 60 },
      { key: 'second', seconds: 1 }
    ];
    if (!value) return value;

    let seconds = (+new Date(value) - +new Date()) / 1000;
    const sign = Math.sign(seconds);
    seconds = Math.floor(Math.abs(seconds));

    const isEn = this.translate.currentLang === 'en';
    const suffix = customSuffix
      ?? this.translate.instant(sign === -1 ? 'meetings.ago' : 'meetings.left');

    for (let idx = 0; idx < units.length; idx++) {
      const counter = Math.floor(seconds / units[idx].seconds);
      if (counter > 0) {
        let result = this.calculateTime(counter, units[idx].key, isEn);
        const next = units[idx + 1];
        if (next) {
          const rest = seconds - counter * units[idx].seconds;
          const nextCounter = Math.floor(rest / next.seconds);
          result += ' ' + this.calculateTime(nextCounter, next.key, isEn);
        }
        return isEn ? `${result} ${suffix}` : `${suffix} ${result}`;
      }
    }
    return `0 ${this.translate.instant('general.second')} ${suffix}`;
  }


  calculateTime(counter: number, key: string, isEn: boolean): string {
    const unit = this.translate.instant('general.' + key);
    return isEn && counter !== 1 ? `${counter} ${unit}s` : `${counter} ${unit}`;
  }
}
